import React from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Building2, LogOut, Home, ShoppingCart, Package, Wallet } from "lucide-react";

const navItems = [
  { to: "/mayorista", icon: Home, label: "Inicio", end: true },
  { to: "/mayorista/comprar", icon: ShoppingCart, label: "Comprar" },
  { to: "/mayorista/pedidos", icon: Package, label: "Pedidos" },
  { to: "/mayorista/cuenta", icon: Wallet, label: "Cuenta" },
];

export default function MayoristaLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-[#FBF5E8] flex flex-col">
      <header className="bg-white border-b border-[#E5D4B3] px-4 py-3 sticky top-0 z-40">
        <div className="flex items-center justify-between max-w-5xl mx-auto">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-blue-800 rounded-full flex items-center justify-center">
              <Building2 className="w-5 h-5 text-white" />
            </div>
            <div>
              <h1 className="font-['Playfair_Display'] text-lg text-[#4A2C0A] font-bold leading-tight">
                Portal Mayorista
              </h1>
              <p className="text-xs text-[#4A2C0A]/60">{user?.nombre}</p>
            </div>
          </div>
          <Button variant="ghost" size="sm" onClick={handleLogout} data-testid="mayorista-logout-btn">
            <LogOut className="w-4 h-4" />
          </Button>
        </div>
      </header>

      <main className="flex-1 p-4 pb-24 max-w-5xl mx-auto w-full">
        <Outlet />
      </main>

      <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-[#E5D4B3] z-40">
        <div className="flex justify-around max-w-5xl mx-auto">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `flex flex-col items-center gap-1 py-2.5 px-4 text-xs font-medium transition-colors ${
                  isActive ? "text-blue-800" : "text-gray-400"
                }`
              }
              data-testid={`mayorista-nav-${item.label.toLowerCase()}`}
            >
              <item.icon className="w-5 h-5" />
              {item.label}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
